// 10% of penal amount: $50 minimum.

/* eslint-disable */
export const equation = ({ bondValue, minimum = 50, percentage = .1 }) => {
  let condition = null
  let value = (bondValue * percentage)
  if (minimum !== 0 && value < minimum) {
    value = minimum
    condition = 'Minimum not met'
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation